var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01511 19V17H21.0151V19H9.01511ZM9.01511 13V11H21.0151V13H9.01511ZM9.01511 7V5H21.0151V7H9.01511ZM5.01511 20C4.46511 20 3.99427 19.8042 3.60261 19.4125C3.21094 19.0208 3.01511 18.55 3.01511 18C3.01511 17.45 3.21094 16.9792 3.60261 16.5875C3.99427 16.1958 4.46511 16 5.01511 16C5.56511 16 6.03594 16.1958 6.42761 16.5875C6.81927 16.9792 7.01511 17.45 7.01511 18C7.01511 18.55 6.81927 19.0208 6.42761 19.4125C6.03594 19.8042 5.56511 20 5.01511 20ZM5.01511 14C4.46511 14 3.99427 13.8042 3.60261 13.4125C3.21094 13.0208 3.01511 12.55 3.01511 12C3.01511 11.45 3.21094 10.9792 3.60261 10.5875C3.99427 10.1958 4.46511 10 5.01511 10C5.56511 10 6.03594 10.1958 6.42761 10.5875C6.81927 10.9792 7.01511 11.45 7.01511 12C7.01511 12.55 6.81927 13.0208 6.42761 13.4125C6.03594 13.8042 5.56511 14 5.01511 14ZM5.01511 8C4.46511 8 3.99427 7.80417 3.60261 7.4125C3.21094 7.02083 3.01511 6.55 3.01511 6C3.01511 5.45 3.21094 4.97917 3.60261 4.5875C3.99427 4.19583 4.46511 4 5.01511 4C5.56511 4 6.03594 4.19583 6.42761 4.5875C6.81927 4.97917 7.01511 5.45 7.01511 6C7.01511 6.55 6.81927 7.02083 6.42761 7.4125C6.03594 7.80417 5.56511 8 5.01511 8Z",
    fill: "#343F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorBullet);
export default __webpack_public_path__ + "static/media/editor-bullet.90954affe7c15c509c44d64cb35863cc.svg";
export { ForwardRef as ReactComponent };